import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './SportsIndex.css';

// ✅ Import Bishop Games Logo
import bishopGamesLogo from '../img/bishop_games_logo.png';

// ✅ Import custom sport images
import croquetIcon from '../img/croquet_img.png';
import pickleballIcon from '../img/pickle_ball_img.png';
import satodiyuIcon from '../img/satodiyu_img.png';
import carromIcon from '../img/carrom.png';

// ✅ Import ALL sponsor logos
import twpLogo from '../img/twp_logo.jpeg';
import lifelensLogo from '../img/lifelens_logo.jpeg';
import chakrumLogo from '../img/chakrum_logo.jpeg';
import aadicuraLogo from '../img/aadicura_logo.svg';
import ashtamLogo from '../img/ashtam_tech_logo.png';
import yellow360Logo from '../img/yellow_360_logo.png';
import nnLogo from '../img/nadiad_nexus_logo.png';
import kewalLogo from '../img/kewal_prints_logo.png';
import jiyasLogo from '../img/jiyas_logo.png';
import saiFinLogo from '../img/sai_logo.png';
import irishkaLogo from '../img/irishka_logo.jpg';

function SportsIndex() {
  const { tournamentId } = useParams();
  const navigate = useNavigate();
  
  const [tournament, setTournament] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ✅ Sports data (9 sports)
  const sports = [
    { 
      id: 'badminton', 
      name: 'Badminton', 
      icon: '🏸',
      useEmoji: true,
      color: '#fcec90ff',
      description: 'Doubles tournament with group stages'
    },
    { 
      id: 'box-cricket', 
      name: 'Box Cricket', 
      icon: '🏏',
      useEmoji: true,
      color: '#fcec90ff',
      description: 'Indoor cricket championship'
    },
    { 
      id: 'football', 
      name: 'Futsal', 
      icon: '⚽',
      useEmoji: true,
      color: '#fcec90ff',
      description: '5-a-side football tournament'
    },
    { 
      id: 'volleyball', 
      name: 'Volleyball', 
      icon: '🏐',
      useEmoji: true,
      color: '#fcec90ff',
      description: 'Team volleyball competition'
    },
    { 
      id: 'carrom', 
      name: 'Carrom', 
      iconImage: carromIcon,
      useEmoji: false,
      color: '#fcec90ff',
      description: 'Singles and doubles carrom'
    },
    { 
      id: 'table-tennis', 
      name: 'Table Tennis', 
      icon: '🏓',
      useEmoji: true,
      color: '#fcec90ff',
      description: 'Fast-paced ping pong matches'
    },
    { 
      id: 'croquet', 
      name: 'Croquet', 
      iconImage: croquetIcon,
      useEmoji: false,
      color: '#fcec90ff',
      description: 'Lawn game with mallets and balls'
    },
    { 
      id: 'pickleball', 
      name: 'Pickleball', 
      iconImage: pickleballIcon,
      useEmoji: false,
      color: '#fcec90ff',
      description: 'Paddle sport combining tennis and badminton'
    },
    { 
      id: 'satodiyu', 
      name: 'Satodiyu', 
      iconImage: satodiyuIcon,
      useEmoji: false,
      color: '#fcec90ff',
      description: 'Traditional Indian outdoor game'
    }
  ];

  // ✅ NEW STRUCTURE: Powered By (LifeLens only)
  const poweredBySponsors = [
    {
      id: 'lifelens',
      name: 'LifeLens Interior',
      logo: lifelensLogo,
      memberName: 'Ms. Riya Dave',
      chapter: 'BNI Egan'
    }
  ];

  // ✅ NEW STRUCTURE: Co-Sponsor (Aadicura only)
  const coSponsors = [
    {
      id: 'aadicura',
      name: 'Aadicura',
      logo: aadicuraLogo,
      memberName: 'Aadicura',
      chapter: 'Superspeciality Hospital'
    }
  ];

  // ✅ NEW STRUCTURE: Valued Partners (All other 9 sponsors)
  const valuedPartners = [
    {
      id: 'twp',
      category: 'Photo & Video Partner',
      logo: twpLogo,
      memberName: 'Mr. Niravkumar Jaiswal',
      chapter: 'BNI Vulcan'
    },
    {
      id: 'kewal',
      category: 'Prize & Trophy Partner',
      logo: kewalLogo,
      memberName: 'Mr. Veer Kewalramani',
      chapter: 'BNI Pegasus'
    },
    {
      id: 'chakrum',
      category: 'PR Partner',
      logo: chakrumLogo,
      memberName: 'Ms. Unnati Gala',
      chapter: 'BNI EOS'
    },
    {
      id: 'ashtam',
      category: 'IT Partner',
      logo: ashtamLogo,
      memberName: 'Mr. Amit Mavani',
      chapter: 'BNI Apricus'
    },
    {
      id: 'yellow360',
      category: 'Socialmedia & Branding Partner',
      logo: yellow360Logo,
      memberName: 'Mr. Umang Pradsanii',
      chapter: 'BNI Pegasus'
    },
    {
      id: 'nadiadnexus',
      category: 'Box Cricket Sponsor',
      logo: nnLogo,
      memberName: 'Mr. Jeet Patel',
      chapter: 'BNI Kinesis'
    },
    {
      id: 'irishka',
      category: 'Chess Sponsor',
      logo: irishkaLogo,
      memberName: 'Ms. Sunita Barad',
      chapter: 'BNI Egan'
    },
    {
      id: 'jiyas',
      category: 'Badminton Sponsor',
      logo: jiyasLogo,
      memberName: 'Ms. Purabi Prajapati',
      chapter: 'BNI Kinesis'
    },
    {
      id: 'saifin',
      category: 'Carrom Sponsor',
      logo: saiFinLogo,
      memberName: 'Ms. Pitamber Tahiliani',
      chapter: 'BNI Egan'
    }
  ];

  useEffect(() => {
    fetchTournamentData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tournamentId]);

  const fetchTournamentData = async () => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem('token') || localStorage.getItem('Token');

      if (!token) {
        setTournament({ 
          tournamentName: 'Bishop Games 6.0',
          venue: 'Vadodara - Anand'
        });
        setLoading(false);
        return;
      }

      const response = await fetch(
        `https://api.asterickx.com/api/Tournaments/${tournamentId}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.ok) {
        const data = await response.json();
        setTournament(data);
      } else {
        setTournament({ 
          tournamentName: 'Bishop Games 6.0',
          venue: 'Vadodara - Anand'
        });
      }

      setLoading(false);
    } catch (err) {
      console.error('Error fetching tournament:', err);
      setTournament({ 
        tournamentName: 'Bishop Games 6.0',
        venue: 'Vadodara - Anand'
      });
      setLoading(false);
    }
  };

  const handleSportClick = (sportId) => {
    navigate(`/tournament-draws/${tournamentId}/${sportId}`);
  };

  if (loading) {
    return (
      <div className="sports-index-container">
        <div className="loading-state">
          <div className="spinner-border text-primary" role="status"></div>
          <p className="mt-3">Loading sports...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="sports-index-container">
        <div className="error-state">
          <i className="fas fa-exclamation-circle fa-3x text-danger mb-3"></i>
          <h4>Error Loading Sports</h4>
          <p>{error}</p>
          <button className="btn btn-primary" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="sports-index-container">
      {/* Header */}
      <div className="sports-header">
        <div className="header-content">
                  <button className="back-btn-dashboard" onClick={() => navigate(`/tournament-dashboard/${tournamentId}`)}>
          <i className="fas fa-arrow-left me-2"></i>
          Go to Dashboard
        </button>
          <h1 className="sports-title">
            <i className="fas fa-trophy me-3"></i>
            Select a Sport
          </h1>
          <p className="sports-subtitle">
            {tournament?.tournamentName || 'Tournament'}
          </p>
          <p className="sports-venue">
            <i className="fas fa-map-marker-alt me-2"></i>
            {tournament?.venue || 'Venue'}
          </p>
        </div>
      </div>

      {/* Sports Grid */}
      <div className="sports-content">
        <p className="sports-instruction">
          Click on any sport to view its tournament draws, groups, and match schedule.
        </p>
        <p className="sports-instruction">
          Chess draws will be made available on the day of matches on 19-12-2025.
        </p>
        
        <div className="sports-grid">
          {sports.map((sport, index) => (
            <div
              key={sport.id}
              className="sport-card"
              onClick={() => handleSportClick(sport.id)}
              style={{ 
                animationDelay: `${index * 0.1}s`
              }}
            >
              <div className="sport-card-inner" style={{ 
                background: `linear-gradient(135deg, ${sport.color} 0%, ${sport.color}dd 100%)`
              }}>
                {sport.useEmoji ? (
                  <div className="sport-icon">{sport.icon}</div>
                ) : (
                  <img 
                    src={sport.iconImage} 
                    alt={sport.name} 
                    className="sport-icon-image"
                  />
                )}
                
                <h3 className="sport-name">{sport.name}</h3>
                <p className="sport-description">{sport.description}</p>
                <div className="sport-action">
                  <span>View Draws</span>
                  <i className="fas fa-arrow-right ms-2"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ============================================
          ✅ REDESIGNED SPONSORS STRUCTURE
          ============================================ */}
      <div className="sponsors-main-section">
        
        {/* ✅ SECTION 1: EVENT (Bishop Games Logo) */}
        <div className="event-section">
          <h2 className="section-title">Event</h2>
          <div className="bishop-logo-container">
            <img 
              src={bishopGamesLogo} 
              alt="Bishop Games Season 6" 
              className="bishop-logo"
            />
          </div>
          <p className="bishop-subtitle">Season 6 - 2025</p>
        </div>

        {/* ✅ SECTION BREAK */}
        <div className="section-divider">
          <div className="divider-line"></div>
        </div>

        {/* ✅ SECTION 2: POWERED BY & CO-SPONSOR (Side by Side) */}
        <div className="powered-cosponsor-section">
          
          {/* Powered By - LifeLens */}
          <div className="sponsor-block">
            <h2 className="section-title">Powered By</h2>
            <div className="sponsor-cards-container">
              {poweredBySponsors.map((sponsor, index) => (
                <div 
                  key={sponsor.id} 
                  className="main-sponsor-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="main-sponsor-logo-wrapper">
                    <img 
                      src={sponsor.logo} 
                      alt={sponsor.name}
                      className="main-sponsor-logo"
                    />
                  </div>
                  <div className="main-sponsor-info">
                    <p className="main-sponsor-name">{sponsor.name}</p>
                    <p className="member-name">{sponsor.memberName}</p>
                    <p className="member-chapter">{sponsor.chapter}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Co-Sponsor - Aadicura */}
          <div className="sponsor-block">
            <h2 className="section-title">Co-Sponsor</h2>
            <div className="sponsor-cards-container">
              {coSponsors.map((sponsor, index) => (
                <div 
                  key={sponsor.id} 
                  className="main-sponsor-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="main-sponsor-logo-wrapper">
                    <img 
                      src={sponsor.logo} 
                      alt={sponsor.name}
                      className="main-sponsor-logo"
                    />
                  </div>
                  <div className="main-sponsor-info">
                    <p className="main-sponsor-name">{sponsor.name}</p>
                    <p className="member-name">{sponsor.memberName}</p>
                    <p className="member-chapter">{sponsor.chapter}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* ✅ SECTION BREAK */}
        <div className="section-divider">
          <div className="divider-line"></div>
        </div>

        {/* ✅ SECTION 3: VALUED PARTNERS (9 Cards) */}
        <div className="valued-partners-section">
          <h2 className="section-title">
            <span className="partners-icon">🤝</span>
            Our Valued Partners
          </h2>
          <p className="partners-subtitle">
            Thank you to our partners for making this tournament possible
          </p>

          <div className="valued-partners-grid">
            {valuedPartners.map((partner, index) => (
              <div 
                key={partner.id} 
                className="valued-partner-card"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                {/* Category Badge */}
                <div className="partner-category">
                  {partner.category}
                </div>

                {/* Logo */}
                <div className="partner-logo-wrapper">
                  <img 
                    src={partner.logo} 
                    alt={partner.category}
                    className="partner-logo"
                  />
                </div>

                {/* Member Details */}
                <div className="partner-member-info">
                  <p className="member-name">{partner.memberName}</p>
                  <p className="member-chapter">{partner.chapter}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="partners-footer">
            <p>Interested in becoming a partner? Contact us for partnership opportunities!</p>
          </div>
        </div>

      </div>

      {/* Info Section */}
      <div className="info-section">
        <div className="info-card">
          <i className="fas fa-users info-icon"></i>
          <h4>Tournament Groups</h4>
          <p>View team groupings and positions for each sport</p>
        </div>
        <div className="info-card">
          <i className="fas fa-calendar-check info-icon"></i>
          <h4>Match Schedule</h4>
          <p>Complete round-robin match schedules</p>
        </div>
        <div className="info-card">
          <i className="fas fa-medal info-icon"></i>
          <h4>Live Updates</h4>
          <p>Real-time scores and tournament progress</p>
        </div>
      </div>
    </div>
  );
}

export default SportsIndex;